


































import { Vue, Component, Prop } from "vue-property-decorator";

@Component({

})
export default class Modal extends Vue {

    @Prop() minWidth: number | undefined;
    @Prop() maxWidth: number | undefined;
    @Prop({ default: 16 }) padding: number | undefined;
    @Prop({ default: undefined }) paddingTop: number | undefined;

    close() {
        this.$emit('close')
    }

    get $s() {
        return this.$style
    }

    get wrapperStyle() {
        return {
            maxWidth: `${this.maxWidth}px`,
            minWidth: `${this.minWidth}px`
        }
    }

    get windowStyle() {
        return {
            padding: `${this.padding}px`,
            paddingTop: `${this.paddingTop}px`
        }
    }
}
